export const newsletterCategory = {
  analysisAndOpinion: {
    entityId: "520771",
  },
  bizTechAndEconomy: {
    entityId: "500007",
  },
  chinaAndAsiaUnpacked: {
    entityId: "500004",
  },
  educationAndParents: {
    entityId: "520773",
  },
  essential: {
    entityId: "500003",
  },
  everythingHongKong: {
    entityId: "520772",
  },
  lifestyleAndWeekend: {
    entityId: "500006",
  },
  picturesFilmsAndVideo: {
    entityId: "500005",
  },
  sport: {
    entityId: "500008",
  },
  subscriberOnly: {
    entityId: "521523",
  },
};

export const newsletter = {
  abacus: {
    entityId: "327098",
    entityLabel: "ABACUS",
  },
  asia: {
    entityId: "323063",
    entityLabel: "THIS WEEK IN ASIA",
  },
  behindTheHeadlines: {
    entityId: "521375",
    entityLabel: "Behind the Headlines",
  },
  betterLife: {
    entityId: "502407",
    entityLabel: undefined,
  },
  breakingNews: {
    entityId: "323473",
    entityLabel: "BREAKING NEWS ALERTS",
  },
  chinaAtAGlance: {
    entityId: "322279",
    entityLabel: "China at a Glance",
  },
  chinaBusinessBriefing: {
    entityId: "324680",
    entityLabel: undefined,
  },
  coronavirus: {
    entityId: "505280",
    entityLabel: "CONFIRMED CORONAVIRUS CASES",
  },
  dailyPulse: {
    entityId: "517578",
    entityLabel: "Daily Pulse",
  },
  darkMatters: {
    entityId: "520815",
    entityLabel: "Dark Matters",
  },
  exclusive: {
    entityId: "324915",
    entityLabel: undefined,
  },
  globalImpact: {
    entityId: "506194",
    entityLabel: "SCMP Global Impact Newsletter",
  },
  hkBusinessBriefing: {
    entityId: "324679",
    entityLabel: undefined,
  },
  hongKongUpdate: {
    entityId: "510083",
    entityLabel: "Hong Kong Update",
  },
  hundredTopTable: {
    entityId: "519979",
    entityLabel: undefined,
  },
  inPictures: {
    entityId: "324669",
    entityLabel: undefined,
  },
  insideChinaTech: {
    entityId: "329707",
    // cspell: ignore INSIDECHINATECH
    entityLabel: "INSIDECHINATECH",
  },
  kPop: {
    entityId: "507747",
    entityLabel: undefined,
  },
  lifeAndCulture: {
    entityId: "322280",
    entityLabel: undefined,
  },
  listeningPost: {
    entityId: "511120",
    entityLabel: undefined,
  },
  longReads: {
    entityId: "324615",
    entityLabel: undefined,
  },
  lunar: {
    entityId: "501957",
    entityLabel: undefined,
  },
  marketsToday: {
    entityId: "500264",
    entityLabel: undefined,
  },
  martialArts: {
    entityId: "502648",
    entityLabel: undefined,
  },
  myNews: {
    entityId: "521524",
  },
  opinion: {
    entityId: "323850",
    entityLabel: undefined,
  },
  postMag: {
    entityId: "322743",
    entityLabel: "POST MAGAZINE",
  },
  racing: {
    entityId: "323665",
    entityLabel: "HK RACING",
  },
  scmpProperty: {
    entityId: "322281",
    entityLabel: undefined,
  },
  scmpTodayHk: {
    entityId: "20916",
    entityLabel: "SCMP TODAY: HK EDITION",
  },
  scmpTodayInt: {
    entityId: "322277",
    entityLabel: "SCMP TODAY: INTL EDITION",
  },
  sportingWeekend: {
    entityId: "519808",
    entityLabel: undefined,
  },
  style: {
    entityId: "322992",
    entityLabel: undefined,
  },
  supportScmp1: {
    entityId: "506605",
    entityLabel: undefined,
  },
  supportScmp2: {
    entityId: "506677",
    entityLabel: undefined,
  },
  supportScmp3: {
    entityId: "506597",
    entityLabel: undefined,
  },
  supportScmp4: {
    entityId: "506696",
    entityLabel: undefined,
  },
  thisWeekInAsia: {
    entityId: "323063",
    entityLabel: undefined,
  },
  usChinaTradeWar: {
    entityId: "330177",
    entityLabel: undefined,
  },
  video: {
    entityId: "323511",
    entityLabel: undefined,
  },
};

export type NewsletterPackageDetail = {
  childNewsletterIds: string[];
  packageDisplayName: string;
  packageId: string;
};

export type ValidNewsletterPackageKey =
  | "Analysis & Opinion"
  | "BizTech & Economy"
  | "China & Asia unpacked"
  | "Essential"
  | "Everything Hong Kong"
  | "Lifestyle"
  | "Pictures, Films & Video"
  | "Sport";

//do not change the order of the newsletters in the childNewsletterIds array. referencing the excel file for the order.
export const NEWSLETTER_PACKAGES: Readonly<
  Record<ValidNewsletterPackageKey, NewsletterPackageDetail>
> = {
  "Analysis & Opinion": {
    childNewsletterIds: [
      newsletter.globalImpact.entityId,
      newsletter.darkMatters.entityId,
      newsletter.opinion.entityId,
      newsletter.breakingNews.entityId,
    ],
    packageDisplayName: "Commentary Bundle",
    packageId: "analysis_opinion_pkg",
  },
  "BizTech & Economy": {
    childNewsletterIds: [
      newsletter.chinaBusinessBriefing.entityId,
      newsletter.insideChinaTech.entityId,
      newsletter.marketsToday.entityId,
      newsletter.breakingNews.entityId,
    ],
    packageDisplayName: "BizTech & Economy Bundle",
    packageId: "biz_tech_econ_pkg",
  },
  "China & Asia unpacked": {
    childNewsletterIds: [
      newsletter.chinaAtAGlance.entityId,
      newsletter.thisWeekInAsia.entityId,
      newsletter.globalImpact.entityId,
      newsletter.breakingNews.entityId,
    ],
    packageDisplayName: "Asia & China Bundle",
    packageId: "china_asia_unpacked_pkg",
  },
  Essential: {
    childNewsletterIds: [
      newsletter.scmpTodayInt.entityId,
      newsletter.chinaAtAGlance.entityId,
      newsletter.breakingNews.entityId,
      newsletter.exclusive.entityId,
    ],
    packageDisplayName: "Essential Bundle",
    packageId: "essential_pkg",
  },
  "Everything Hong Kong": {
    childNewsletterIds: [
      newsletter.scmpTodayHk.entityId,
      newsletter.hongKongUpdate.entityId,
      newsletter.lifeAndCulture.entityId,
      newsletter.postMag.entityId,
    ],
    packageDisplayName: "City Bundle",
    packageId: "everything_hk_pkg",
  },
  Lifestyle: {
    childNewsletterIds: [
      newsletter.lifeAndCulture.entityId,
      newsletter.postMag.entityId,
      newsletter.hundredTopTable.entityId,
      newsletter.style.entityId,
    ],
    packageDisplayName: "Lifestyle Bundle",
    packageId: "lifestyle_pkg",
  },
  "Pictures, Films & Video": {
    childNewsletterIds: [newsletter.inPictures.entityId],
    packageDisplayName: "Best of Video & Pictures",
    packageId: "pictures_films_video_pkg",
  },
  Sport: {
    childNewsletterIds: [newsletter.sportingWeekend.entityId],
    packageDisplayName: "Sport",
    packageId: "sport_pkg",
  },
};

export type ValidNewsletterSequenceMapKey =
  | NewsletterSequenceMapHomepageKey
  | NewsletterSequenceMapLiveKey
  | NewsletterSequenceMapSectionKey;
type NewsletterSequenceMapHomepageKey = "HP/ASIA" | "HP/HK" | "HP/INT";
type NewsletterSequenceMapLiveKey = "Live";
type NewsletterSequenceMapSectionKey =
  | "Business"
  | "China"
  | "Comment"
  | "Economy"
  | "Hong Kong"
  | "Lifestyle"
  | "People & Culture"
  | "Tech"
  | "This Week in Asia"
  | "World";

//do not change the order of the newsletters in the childNewsletterIds array. referencing the excel file for the order.
export const NEWSLETTER_SEQUENCE_MAP: Readonly<
  Record<ValidNewsletterSequenceMapKey, ValidNewsletterPackageKey[]>
> = {
  Business: ["BizTech & Economy", "China & Asia unpacked", "Analysis & Opinion", "Essential"],
  China: ["China & Asia unpacked", "BizTech & Economy", "Analysis & Opinion", "Essential"],
  Comment: ["Analysis & Opinion", "China & Asia unpacked", "BizTech & Economy"],
  Economy: ["BizTech & Economy", "China & Asia unpacked", "Analysis & Opinion", "Essential"],
  "Hong Kong": ["Everything Hong Kong", "Lifestyle", "BizTech & Economy", "China & Asia unpacked"],
  "HP/ASIA": ["China & Asia unpacked", "Lifestyle", "Pictures, Films & Video"],
  "HP/HK": ["Everything Hong Kong", "Lifestyle", "BizTech & Economy", "China & Asia unpacked"],
  "HP/INT": ["Essential", "China & Asia unpacked", "BizTech & Economy", "Analysis & Opinion"],
  Lifestyle: ["Lifestyle", "Everything Hong Kong", "Pictures, Films & Video"],
  Live: ["Essential", "China & Asia unpacked", "BizTech & Economy", "Analysis & Opinion"],
  "People & Culture": ["Lifestyle", "Everything Hong Kong", "Pictures, Films & Video"],
  Tech: ["BizTech & Economy", "China & Asia unpacked", "Analysis & Opinion", "Essential"],
  "This Week in Asia": ["China & Asia unpacked", "Lifestyle", "Pictures, Films & Video"],
  World: ["Essential", "China & Asia unpacked", "Analysis & Opinion", "BizTech & Economy"],
};

export const NEWSLETTER_BUNDLES = [
  {
    displayName: NEWSLETTER_PACKAGES.Essential.packageDisplayName,
    newsletters: [
      newsletter.scmpTodayInt.entityId,
      newsletter.chinaAtAGlance.entityId,
      newsletter.breakingNews.entityId,
      newsletter.exclusive.entityId,
    ],
  },
  {
    displayName: NEWSLETTER_PACKAGES["Everything Hong Kong"].packageDisplayName,
    newsletters: [
      newsletter.scmpTodayHk.entityId,
      newsletter.hongKongUpdate.entityId,
      newsletter.lifeAndCulture.entityId,
      newsletter.postMag.entityId,
    ],
  },
  {
    displayName: NEWSLETTER_PACKAGES["BizTech & Economy"].packageDisplayName,
    newsletters: [
      newsletter.chinaBusinessBriefing.entityId,
      newsletter.insideChinaTech.entityId,
      newsletter.marketsToday.entityId,
      newsletter.breakingNews.entityId,
    ],
  },
  {
    displayName: NEWSLETTER_PACKAGES["China & Asia unpacked"].packageDisplayName,
    newsletters: [
      newsletter.chinaAtAGlance.entityId,
      newsletter.thisWeekInAsia.entityId,
      newsletter.globalImpact.entityId,
      newsletter.breakingNews.entityId,
    ],
  },
  {
    displayName: NEWSLETTER_PACKAGES.Lifestyle.packageDisplayName,
    newsletters: [
      newsletter.lifeAndCulture.entityId,
      newsletter.postMag.entityId,
      newsletter.hundredTopTable.entityId,
      newsletter.style.entityId,
    ],
  },
  {
    displayName: NEWSLETTER_PACKAGES["Analysis & Opinion"].packageDisplayName,
    newsletters: [
      newsletter.globalImpact.entityId,
      newsletter.darkMatters.entityId,
      newsletter.opinion.entityId,
      newsletter.breakingNews.entityId,
    ],
  },
];
